// Funções auxiliares para verificar limite de peso do carrinho
// Uso: await window.CartWeightChecker.willExceedLimit(variantWeight, quantity)

window.CartWeightChecker = {
    currentCart: null,
    listeners: [],
    
    // Buscar carrinho atual
    async fetchCart() {
        try {
            const response = await fetch('/cart.js');
            this.currentCart = await response.json();
            
            // Notificar listeners sobre a atualização
            this.listeners.forEach(callback => callback(this.currentCart));
            
            return this.currentCart;
        } catch (error) {
            console.error('Erro ao buscar carrinho:', error);
            return null;
        }
    },
    
    // Adicionar listener para mudanças no carrinho
    onChange(callback) {
        this.listeners.push(callback);
    },
    
    // Verificar se adicionar um item vai exceder o limite
    async willExceedLimit(variantWeight, quantity = 1) {
        if (!window.cartLimitSettings || !window.cartLimitSettings.enable) {
            return false;
        }
        
        const cart = await this.fetchCart();
        if (!cart) return false;
        
        const currentWeight = cart.total_weight || 0;
        const addedWeight = variantWeight * quantity;
        const totalWeight = currentWeight + addedWeight;
        
        return totalWeight > window.cartLimitSettings.maxWeight;
    },
    
    // Obter peso atual do carrinho
    async getCurrentWeight() {
        const cart = await this.fetchCart();
        return cart ? cart.total_weight : 0;
    },
    
    // Obter limite máximo
    getMaxWeight() {
        return window.cartLimitSettings ? window.cartLimitSettings.maxWeight : Infinity;
    },
    
    // Obter texto formatado do aviso
    getWarningText() {
        if (!window.cartLimitSettings) return '';
        const maxKg = (window.cartLimitSettings.maxWeight / 1000).toFixed(2).replace('.', ',');
        return window.cartLimitSettings.text.replace('[weight]', maxKg);
    }
};

